import * as Yup from 'yup';
import { TFunction } from 'i18next';
import { ICompanyInfo } from 'core/interface/matchProfile';
import { isIndustryObject } from 'utils/industry';

const initialValues: ICompanyInfo = {
  industry: null,
  name: ''
};

const validationSchema = (t: TFunction) => {
  return Yup.object({
    industry: Yup.mixed()
      .required(t('required'))
      .test('industry-shape', t('required'), (value) =>
        isIndustryObject(value)
      ),
    name: Yup.string().required(t('required'))
  });
};

export { validationSchema, initialValues };
